
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/gameschedule/[season]/[gameday]/[team]/widget",
      function () {
        return require("private-next-pages/bundesliga/gameschedule/[season]/[gameday]/[team]/widget.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/gameschedule/[season]/[gameday]/[team]/widget"])
      });
    }
  